/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
/* Styles */
import styles from "./styles.js"


const Divider = ({ children }) => {

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.container}>
      <hr className={classes.border}/>
      { children && (
        <span className={classes.dividerContent}>
          {children}
        </span>
      )}
      <hr className={classes.border}/>
    </div>
  );
};


export default Divider;
